var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 7.41021V8.74354H10.6665L6.99984 12.4102L7.9465 13.3569L13.2265 8.07687L7.9465 2.79688L6.99984 3.74354L10.6665 7.41021H2.6665Z",
    fill: "#4B5EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferButtonIcon);
export default __webpack_public_path__ + "static/media/offer-button-icon.4ae92ec5500318a04ea516807ea23748.svg";
export { ForwardRef as ReactComponent };